import { Card, Typography } from 'antd';
import { ChangePasswordForm } from '@ubus/shared';
import { useTranslation } from 'react-i18next';
import AdminSectionPage from '../components/AdminSectionPage';

const { Paragraph } = Typography;

function AccountSecurity() {
  const { t } = useTranslation();
  return (
    <AdminSectionPage
      title={t('accountSecurity.title')}
      subtitle={t('accountSecurity.subtitle')}
    >
      <Card style={{ maxWidth: 480 }}>
        <Paragraph type="secondary" style={{ marginBottom: 16 }}>
          {t('accountSecurity.hint')}
        </Paragraph>
        <ChangePasswordForm
          labels={{
            currentPassword: t('accountSecurity.currentPassword'),
            newPassword: t('accountSecurity.newPassword'),
            confirmPassword: t('accountSecurity.confirmPassword'),
            enterCurrent: t('accountSecurity.enterCurrent'),
            enterNew: t('accountSecurity.enterNew'),
            confirmNew: t('accountSecurity.confirmNew'),
            mismatch: t('accountSecurity.mismatch'),
            tooShort: t('accountSecurity.tooShort'),
            updated: t('accountSecurity.updated'),
            submit: t('accountSecurity.submit'),
          }}
        />
      </Card>
    </AdminSectionPage>
  );
}

export default AccountSecurity;
